import { render, staticRenderFns } from "./AssumptionsResidentialNewBuildingTypes.vue?vue&type=template&id=18f707e7&scoped=true&"
import script from "./AssumptionsResidentialNewBuildingTypes.vue?vue&type=script&lang=js&"
export * from "./AssumptionsResidentialNewBuildingTypes.vue?vue&type=script&lang=js&"
import style0 from "./AssumptionsResidentialNewBuildingTypes.vue?vue&type=style&index=0&id=18f707e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f707e7",
  null
  
)

export default component.exports